<template>
  <div class="hr-control text-left">
    <div class="control-top">
      <h3 class="font18">{{ $l('hrControlTitle') }}Preset HR Supervisor(s)</h3>
      <p class="font16 italic-bold sp-color-1 tip-title">{{ $l("hrControlTipsTitle") }}</p>
      <P class="font16 opacity-50 sp-color-18 tips">{{ $l('hrControlTip') }}</P>
      <div class="flex-jc-bt mg-t-30">
        <div style="width: 120px; padding-top: 20px">
          <SpRadioGroup v-model="info.onlyMe" name="multipleAdmins">
            <sp-radio :value="true" :disabled="onlyMeDisable">
              <span class="desc font16 italic-bold pointer sp-color-1">{{ $l('Only Me') }}</span>
            </sp-radio>
          </SpRadioGroup>
        </div>
        <div class="flex-1">
          <div class="flex-jc-end">
            <SpButton class="mg-r-20" type="back" circle="5" :width="240" :height="70">
              <span class="font18" style="font-weight: bold">{{ $L('back') }}</span>
            </SpButton>

            <SpButton type="primary" :disabled="subDisable" circle="5" :width="240" :height="70" @click="saveInfo">
              <span class="font18" style="font-weight: bold">{{ $L('submit') }}</span>
            </SpButton>
          </div>
        </div>
      </div>
    </div>
    <SpCard class="mg-t-40">
      <div style="min-height: 650px; font-size: 18px">
        <SpTagGroup v-model="info.selectedTag" class="cus-tag-group" @change="tagChange">
          <SpTag v-for="(hr, index) in info.admins" :key="index"
                 :have-close="true"
                 :index="index"
                 :label="hr.id"
                 class="cus-tag">
            <template v-if="index === 0">
              <span style="line-height: 29px" class="font18">Me</span>
              <SpSelect v-model="info.masterJobTitle" select-icon-color="#fff" :show-clear="false" class="cus-select"
                        :need-search="false" :class="{'primary-cus-select': info.selectedTag !== hr.id}"
                        style=" float: right" :width="info.masterJobTitle === 'Boss'? '94' : '120'" type="none" height="30">
                <SpSelectOption key="Boss" label="Boss" value="Boss" />
                <SpSelectOption key="Executive" label="Executive" value="Executive" />
              </SpSelect>
            </template>
            <template v-else>
              <span class="font18">{{ hr.fullName || 'New' }} </span>
              <i v-if="info.admins.length > 1" style="margin-left: 4px; margin-right: 4px" class="font14 icon-close iconfont pointer"
                 @click.capture.stop="delAdmin(index)" />
            </template>
          </SpTag>
          <span v-if="!info.onlyMe" style="font-size: 14px" class="active icon-jiahao iconfont" @click="toAddNewHr" />
          <span v-else style="font-size: 14px" class="icon-jiahao iconfont" />
        </SpTagGroup>

        <p class="me-tip">
          {{ $l('meTip') }}
        </p>

        <HrForm ref="infoForm" v-model="nowForm" :personal-index="info.admins.findIndex((a) =>info.selectedTag === a.id)" @addPerson="addPerson" @comfirmSubt="comfirmSubt" />
      </div>
    </SpCard>
  </div>
</template>

<script>
import SpForm from '@/components/common/SpForm'
import spRadio from '@/components/common/SpRadio'
import SpRadioGroup from '@/components/common/SpRadioGroup'
import SpButton from '@/components/common/SpButton.vue'
import SpCard from '@/components/common/SpCard.vue'
import SpTagGroup from '@/components/common/SpTagGroup.vue'
import SpTag from '@/components/common/SpTag.vue'
import SpInput from '@/components/common/SpInput'
import { reactive, ref, watch } from 'vue'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import spUploadGroup from '@/components/common/SpUploadGroup'
import { computed } from '@vue/runtime-core'
import HrForm from '@/components/hrControl/HrForm-old'
import { enterpriseAdminsApi, enterpriseAdminsUpdateApi } from '@/request/APIs/company'
import SpMessage from '@/components/common/SpMessage'
import _cloneDeep from 'lodash/cloneDeep'
import _forEach from 'lodash/forEach'

export default {
  name: 'Index',
  nameSpace: 'hr',
  components: {
    HrForm,
    SpSelectOption,
    SpSelect,
    spRadio,
    SpForm,
    SpButton,
    SpCard,
    SpTagGroup,
    SpTag,
    SpInput,
    spUploadGroup,
    SpRadioGroup
  },

  setup (props, ctx) {
    // 生成id
    const getId = (length) => {
      return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36)
    }
    const infoForm = ref(null)
    const defaultForm = {
      fullName: null,
      fullNameNative: null,
      jobTitle: null,
      title: null,
      password: null,
      passwordConfirmation: null,
      avatar: [],
      passwordSet: false
    }
    const nowForm = ref({})
    // 获取企业管理员
    const getEnterpriseAdmins = () => {
      enterpriseAdminsApi().then(res => {
        if (res.code === 1) {
          info.onlyMe = res.data.multipleAdmins === 0
          if (res.data?.admins.length > 0) {
            info.admins = res.data.admins.map(admin => ({ ...admin, id: admin.id, avatar: Object.values(admin.avatar).map(url => ({ type: 'img', url })) }))
            info.masterJobTitle = info.admins[0].jobTitle
            info.selectedTag = info.admins[0].id
            nowForm.value = { ...info.admins[0] }
          } else {
            const id = `v${getId(5)}`
            info.admins = [{
              id: id
            }]
            info.selectedTag = id
            nowForm.value = { ...defaultForm, id }
          }
        }
      })
    }
    watch(() => nowForm.value, (nv) => {
      const nowIndex = info.admins.findIndex(ad => ad.id === info.selectedTag)
      info.admins[nowIndex] = nowForm.value
    })

    const tagChange = (tag) => {
      const nowIndex = info.admins.findIndex(ad => ad.id === tag)
      const ifAdmins = _cloneDeep(info.admins)
      const nf = _cloneDeep(info.admins[nowIndex])
      infoForm.value.clearForm()
      nowForm.value = nf
      info.admins = ifAdmins
      info.selectedTag = tag
    }

    getEnterpriseAdmins()
    const info = reactive({
      onlyMe: '',
      type: 1,
      selectedTag: 0,
      admins: [],
      masterJobTitle: 'Boss'
    })

    const submit = () => {

    }
    const saveInfo = () => {
      const iv = infoForm.value.validationForm()
      // const nowIndex = info.admins.findIndex(ad => ad.id === info.selectedTag)
      // info.admins[nowIndex] = nowForm.value
    }
    const comfirmSubt = () => {
      info.admins[0].jobTitle = info.masterJobTitle

      const admins = []
      _forEach(info.admins, (ad, index) => {
        const obj = {
          title: ad.title,
          fullName: ad.fullName,
          fullNameNative: ad.fullNameNative,
          jobTitle: ad.jobTitle,
          password: ad.password,
          passwordConfirmation: ad.passwordConfirmation,
          isMaster: ad.isMaster
        }
        if (!obj.password) delete obj.password
        if (!obj.passwordConfirmation) delete obj.passwordConfirmation
        if (!ad.id.toString().includes('v')) {
          obj.id = ad.id
        } else {
          obj.isMaster = 0
        }
        if (ad.avatar && ad.avatar.length > 0) {
          obj.avatar = ad.avatar[0].file
        } else {
          obj.avatar = ''
        }
        if (index === 0) {
          obj.isMaster = 1
        }
        admins.push(obj)
      })
      const params = {
        admins,
        multipleAdmins: info.onlyMe ? 0 : 1
      }
      const admin = info.admins.find(i => i.isMaster === 1) || info.admins[0]
      if (params.multipleAdmins && !admin.passwordSet && (!admin.password || !admin.passwordConfirmation || (admin.passwordConfirmation !== admin.password))) {
        SpMessage.error(`This password is required of ${admin.fullName},\n The password and confirmation password must be the same`)
        return false
      }
      enterpriseAdminsUpdateApi(params).then(res => {
        if (res.code === 1) {
          SpMessage.success('success！')
          window.location.reload()
        }
      })
    }
    const delAdmin = (index) => {
      if (info.selectedTag === info.admins[index].id) {
        info.selectedTag = info.admins[0].id
        nowForm.value = info.admins[0]
      }
      info.admins.splice(index, 1)
    }

    // submit 禁止点击
    // 1、onlyMe = true && me 的FULL NAME 不为空
    // 2、onlyMe = false && me 的FULL NAME不为空&& 添加一个其他的人FULL NAME 密码填写完成
    const subDisable = computed(() => {
      let haveIllegality = false
      if (info.onlyMe && !info.admins[0].fullName) return true
      if (!info.onlyMe) {
        if (info.admins.length === 1) {
          haveIllegality = true
          return true
        } else {
          _forEach(info.admins, (ad, index) => {
            if (index === 0) {
              if (ad.id.toString().includes('v')) {
                if (!ad.fullName) {
                  return true
                } else {
                  if (!ad.password || !ad.passwordConfirmation || ((ad.password && ad.passwordConfirmation) && ad.password !== ad.passwordConfirmation)) {
                    haveIllegality = true
                  }
                }
              }
            } else {
              if (info.admins[index].id.toString().includes('v')) {
                if (!info.admins[index].fullName || !info.admins[index].password || !info.admins[index].passwordConfirmation || info.admins[index].password !== info.admins[index].passwordConfirmation) {
                  haveIllegality = true
                } else {
                  return false
                }
              } else {
                if (!info.admins[index].fullName) {
                  haveIllegality = true
                }
              }
            }
          })
        }
      }
      return haveIllegality
    })

    // 颜值当前信息
    const toAddNewHr = () => {
      infoForm.value.addPerson()
    }
    // 验证通过，添加信息到列表
    const addPerson = (data, index) => {
      info.admins[index] = { ...data.value }
      const newId = 'v' + getId(5)
      info.admins.push({
        id: newId,
        fullName: '',
        avatar: []
      })
      nowForm.value = { ...defaultForm, id: newId }
      info.selectedTag = newId
    }

    /**
     * onle me 禁止点击
     * admins数组长度大于1
     */
    const onlyMeDisable = computed(() => {
      let disable = false
      const admins = info.admins
      if (admins.length > 1) {
        disable = true
      }
      return disable
    })
    return {
      info,
      subDisable,
      onlyMeDisable,
      nowForm,
      defaultForm,
      infoForm,
      tagChange,
      submit,
      saveInfo,
      delAdmin,
      toAddNewHr,
      addPerson,
      comfirmSubt
    }
  }
}
</script>

<style scoped lang="less">
.icon-jiahao{
  font-weight: bold;
  cursor: not-allowed;
  color: #676767;
  line-height: 44px;
  margin: 0 4px;
  &.active {
    cursor: pointer;
    color: black;
  }
}
.hr-control {
  .content-form{
    width: 800px;
    .right{
      width: 139px;
    }
    .icon-panel{
      width: 32px;
      box-sizing: border-box;
    }
  }
  .avatar-panel {
    position: relative;
    top: -14px;
    .name-label {
      margin: 0;
    }
    .avatar-uploader{
      width: 198px;
      height: 240px;
      position: absolute;
      top: 14px;
    }
  }
  .icon-panel {
    padding-left: 10px;
    .iconfont {
      font-size: 22px;
    }
  }

  .fn-span{
    position: absolute;
    top: -14px;
    color: #000000;
    opacity: 0.8;
  }
  .control-top{
    width: 900px;
  }
  padding: @gap 50px @gap 50px;
  .tip-title, .tips{
    margin: 0;
  }
  .me-tip{
    margin: 6px 0 10px 0;
    width: 116px;
    font-size: 14px;
    line-height: 11px;
    color: #676767;
    opacity: 0.5;
  }

}
</style>

<style lang="less">
.hr-control .SpSelect > .xl-select-label > .selected {
  text-indent: 10px !important;
}

.hr-control .cus-tag-group .SpSelect > .xl-select-label > .selected {
  text-indent: 0 !important;
}

.cus-tag {
  .tag-label {
    padding-right: 0px !important;
  }

}

.cus-select {
  .selected {
    font-size: 18px !important;
    color: #FFFFFF;
    font-weight: 400 !important;
    text-align: right;
  }

  .SpSelectOption {
    .label {
      color: #2e3c50;
    }

    &.sp-color-1 {
      .label {
        color: #3A909D;
      }
    }

  }
}
.primary-cus-select {
  .selected {
    color: #3A909D;
  }

}

.cus-tag-group {
  .SpTag {
    font-size: 18px;
    font-weight: 400;

    .tag-label {
      font-weight: 400 !important;
    }
  }
}
.sp-tag-bg.no-border-tag{
  background: none !important;
}
</style>
